module.exports = __webpack_public_path__ + "public/img/hxz.e3976316.png";